import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const SessionExpiredEvents: AnalyticsBrandSettings = {

  sesionExpiradaPerfilCompradorLogin(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'sesion_expirada', 'login'
    );

    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  }

};
